import { cleanNumber } from "./NumberUtil";
import { isObject } from "./ObjectUtil";
import { localToString, isEmptyValue } from "./StringUtil";
import ResponseCode from "../services/ResponseCode";

export const isValidPassword = (password) => {
  return localToString(password).length > 8;
};

export function isValidPhone(phone) {
  return (
    !!phone && typeof phone === "string" && cleanNumber(phone).length === 10
  );
}

export function isValidEmail(correo) {
  const patronCorreo = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return patronCorreo.test(correo);
}

export const isEmpty = (any, key = "Value", lengthVal = 3) => {
  if (isObject(any)) {
    if (typeof any[key] === "string") {
      return any[key].length === 0;
    } else {
      return !any[key];
    }
  } else if (typeof any === "string") {
    return any.length < lengthVal;
  } else if (typeof any === "number") {
    return any <= 0;
  } else if (Array.isArray(any)) {
    return any.length === 0;
  } else {
    return !any;
  }
};

export const isValidNumber = (value) => {
  if (typeof value === "number") {
    return true;
  }

  if (typeof value === "string") {
    return !isNaN(+value);
  }

  return false;
};

export function camposCompletos(formData) {
  for (const key in formData) {
    if (isEmptyValue(formData[key])) {
      return false;
    }
  }

  return true;
}

export function isServerErrorResponse(response) {
  return (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  );
}

export function isServerErrorResponseCode(response) {
  return (
    isServerErrorResponse(response) ||
    response?.respuesta?.codigo !== ResponseCode.OK.code
  );
}

export function isServerErrorResponseMessage(response) {
  return (
    isServerErrorResponse(response) ||
    response?.respuesta?.mensaje !== ResponseCode.OK.message
  );
}
